import * as React from "react";
const SvgCamera = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M33.586 37.586A2 2 0 0 0 33 39v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2h-.93a2 2 0 0 1-1.664-.89l-.812-1.22A2 2 0 0 0 43.93 34h-3.86a2 2 0 0 0-1.664.89l-.812 1.22a2 2 0 0 1-1.664.89H35a2 2 0 0 0-1.414.586" />
      <path d="M44.121 45.121a3 3 0 1 0-4.242-4.242 3 3 0 0 0 4.242 4.242" />
    </g>
  </svg>
);
export default SvgCamera;
